export const ProColors = {
  navy: {
    800: '#071948',
    700: '#36456B',
    600: '#515E7F',
    500: '#838CA3',
    400: '#B5BAC8',
    300: '#E6E8ED',
    200: '#F3F4F6',
    100: '#F8F8FA',
  },
  blue: {
    700: '#2C25A5',
    600: '#4036ED',
    400: '#7972F2',
    200: '#B2AEF7',
    100: '#EBEAFD',
  },
  coral: {
    700: '#B24748',
    600: '#FF6668',
    400: '#FF9395',
    200: '#FFC1C2',
    100: '#FFEFEF',
  },
  teal: {
    700: '#0B8A90',
    600: '#11C6CF',
    400: '#58D7DD',
    200: '#9FE8EB',
    100: '#E7F9FA',
  },
  yellow: {
    700: '#B28E35',
    600: '#FFCB4D',
    400: '#FFDA82',
    200: '#FFEAB7',
    100: '#FFF9ED',
  },
  purple: {
    700: '#633EB2',
    600: '#8E5AFF',
    400: '#AF8BFF',
    200: '#D1BDFF',
    100: '#F3EEFF',
  },
  pink: {
    700: '#B28085',
    600: '#FFB8BE',
    400: '#FFCDD1',
    200: '#FFE2E5',
    100: '#FFF7F8',
  },
  white: '#FFFFFF',
  black: '#000000',
  transparent: 'rgba(0, 0, 0, 0)',
};
